{firebaseRef} = require 'lib/firebase'
auth = require 'models/auth'

module.exports = class FeedbackCollection extends Backbone.Firebase.Collection
    initialize: (attrs, options={}) ->
        {id} = options
        accountId = @accountId ? auth.currentAccount.id
        @url = firebaseRef.child "feedback/#{id}/#{accountId}"
        return
